import { h, Component } from 'preact';
import isShallowEqual from 'shallow-equals';
import Store from 'store/store';
import 'store/bolt/showtimes';

import Theater from 'components/bolt/showtimes/theater';
import LocationSearch from 'components/bolt/showtimes/locationSearch2';
import DateScroller from 'components/bolt/showtimes/dateScroller';
import FilterSelection from 'components/bolt/showtimes/filterSelection2';
import IconFilter from 'components/bolt/icons/filter';
import IconList from 'components/bolt/icons/list';
import IconMap from 'components/bolt/icons/map';
import Walk from 'components/bolt/icons/walk';
import Car from 'components/bolt/icons/car';
import Rail from 'components/bolt/icons/rail';
import Button from 'components/bolt/button/button';
import ProviderInterstitial from 'components/bolt/showtimes/providerInterstitial';
import ShowtimesMessage from 'components/bolt/showtimes/showtimesMessage';
// TODO: dynamic imports to avoid loading unecessary code
import NotificationBanner from 'components/bolt/sidePanel/notificationBanner';
import QuotesCarousel from 'components/bolt/quotesCarousel/quotesCarousel';
import LoadIcon from 'components/bolt/sidePanel/loadIcon';
import Footer from 'components/bolt/footer/footer';
import MovieDetails from 'components/bolt/movieDetails/movieDetails';
import MovieDetailsClickableArea from 'components/bolt/movieDetails/movieDetailsClickableArea';
import DualMenu from 'components/bolt/dualMenu/dualMenu';
import { createMarker } from 'components/bolt/showtimes/mapMarker';
import { createMapTilerMarker } from 'components/bolt/showtimes/mapTilerMarker';
import mapStyles from 'components/bolt/showtimes/mapStyles.json';
import QuickFilters from 'components/bolt/showtimes/quickFilters.js';
import Link from 'components/bolt/link/link';
import GroupBookingsInquiry from 'components/bolt/forms/groupBookingsInquiry';
import Tooltip from 'components/bolt/tooltip/tooltip';

import Geo from 'models/Geo';

import { accessNested, joinClasses, toQueryString, addClass, removeClass, parseDate, hasClass, commaSeparatedList, asList } from 'utils/utils';
import { lightness } from 'utils/colors';
import parseQueryString from 'utils/parseQueryString';
import formatDateTime from 'utils/formatDateTime';
import { smoothScrollTo } from 'utils/smoothScroll';
import { getValueForClientSize, isDualViewEnabled, getShowtimesData } from 'utils/bolt';
import { geoFromIP } from 'utils/bolt/geo';
import { getBoundingRegions, getDummyFormDataForGroupBookings } from 'utils/bolt/showtimes';
import { getIsSinglePageIframed, getIsShowtimesOnlyIframed } from 'utils/bolt/client';
import * as gmapsUtils from 'utils/bolt/gmaps';
import * as mapTilerUtils from 'utils/bolt/mapTiler';
import { metaApi } from 'utils/bolt/metaApi';
import DeviceDetector from 'device-detector-js';
import CreativeSpace from 'components/bolt/showtimes/creativeSpace';

import s from 'components/bolt/showtimes/showtimes2.sss';
import { getMovieName } from 'utils/bolt/showtimes';

const theaterModeToSource = {
	list: 'listings_view',
	expanded: 'cinema_view',
	collapsed: 'map_view'
};

const GROUP_BOOKINGS_TAB = 'Group Bookings';
const BOOK_NOW_TAB = 'Book Now';

let TheaterWithIntersectionObserver = withIntersectionObserver(Theater);
// let DateScrollerWithIntersectionObserver = withIntersectionObserver(DateScroller);
let NotificationBannerWithIntersectionObserver = withIntersectionObserver(NotificationBanner);
let QuotesCarouselWithIntersectionObserver = withIntersectionObserver(QuotesCarousel);

export default class Showtimes2 extends Component {
	constructor(props) {
		super(props);

		this.selectTabGroupBookings = this.selectTab.bind(this, GROUP_BOOKINGS_TAB);
		this.selectTabTickets = this.selectTab.bind(this, BOOK_NOW_TAB);
		this.updateShowtimes = this.updateShowtimes.bind(this);
		this.showFilterSelection = this.showFilterSelection.bind(this);
		this.exitEventInquiry = this.exitEventInquiry.bind(this);
		// this.cancelFilterSelection = this.cancelFilterSelection.bind(this);
		this.hideFilterSelection = this.hideFilterSelection.bind(this);
		this.filtersChange = this.filtersChange.bind(this);
		this.setListMode = this.setListMode.bind(this);
		this.setMapMode = this.setMapMode.bind(this);
		this.collapseOnMapClick = this.collapseOnMapClick.bind(this);
		this.setMapModeButton = this.setMapModeButton.bind(this);
		this.expandCurrentMapTheater = this.expandTheater.bind(this, null);
		this.selectNearby = this.selectNearby.bind(this);
		this.selectNearbyFromChain = this.selectNearbyFromChain.bind(this);
		this.hideShowtimes = this.hideShowtimes.bind(this);
		this.toggleMoveDown = this.toggleMoveDown.bind(this);
		this.showMore = this.showMore.bind(this);
		this.updateMapMarkers = this.updateMapMarkers.bind(this);
		this.triggerShowtimesBtn = this.triggerShowtimesBtn.bind(this);
		this.triggerHeaderAction = this.triggerHeaderAction.bind(this);
		this.onMouseDown = this.onMouseDown.bind(this);
		this.onCHTouchStart = this.onCHTouchStart.bind(this);
		this.onCHTouchMove = this.onCHTouchMove.bind(this);
		this.scrollerClick = this.scrollerClick.bind(this);
		this.disableMobileOverlay = this.toggleMobileOverlayActive.bind(this, false);
		this.enableMobileOverlay = this.toggleMobileOverlayActive.bind(this, true);
		this.toggleMobileOverlayActive = this.toggleMobileOverlayActive.bind(this);
		this.handleFilterOverlayClick = this.handleFilterOverlayClick.bind(this);
		this.safariMobileBlur = this.safariMobileBlur.bind(this);
		this.safariMobileFocus = this.safariMobileFocus.bind(this);
		this.handleScroll = this.handleScroll.bind(this);
		this.handleLimitInterstetial = this.handleLimitInterstetial.bind(this);
		this.renderSelectTitleButton = this.renderSelectTitleButton.bind(this);
		this.setGeo = this.setGeo.bind(this);
		this.stickAndScale = this.stickAndScale.bind(this);
		// this.applyQueryStringMovieFilter = this.applyQueryStringMovieFilter.bind(this);
		this.trackConversion = this.trackConversion.bind(this);
		this.updateGroupBookingsFormData = this.updateGroupBookingsFormData.bind(this);
		this.expandTheaterEventInquiry = this.expandTheaterEventInquiry.bind(this);
		this.stickedElementsRefs = {};

		this.filtersList = ['date', 'time', 'format', 'language', 'subtitles'];
		this.defaultChainLogo = 'default.png';

		this.filtersSnapshot = accessNested(props, 'store.showtimes.filters.selected') || {};

		this.$theaterElements = [];

		let pages = accessNested(this.props, 'store.appData.pages', {});
		this.noHome = !Object.keys(pages).includes('boltHome');

		this.boundingRegions = getBoundingRegions();

		this.today = formatDateTime(new Date(), 'dd MMM');

		this.mapDisabled = props.store?.appData?.options?.disableShowtimesMap;
		const mapTilerData = accessNested(this.props, 'store.appData.doc.mapStyling.mapTiler') || {};
		this.useMapTiler = !this.mapDisabled && mapTilerData.id && mapTilerData.key;

		this.userCountry = (accessNested(this.props, 'store.client.geo.countryCode') || '').toUpperCase();

		this.quickFiltersData = this.getPageData().quickFilters || {};

		const movieId = this.getPageData().movieId || '';
		this.isMultiMovie = movieId.trim().split(',').filter(id => id).map(id => id.trim())?.length > 1;

		const styling = this.props.store?.appData?.styling;
		this.logoShade = accessNested(this.props, 'store.appData.styling.logoShade', null);

		this.useGroupBookingsDummyFormData = accessNested(this.props, 'store.appData.pages.boltShowtimes.data.groupBookings.dummyFormData', false) && (__IS_LOCAL__ || __IS_DEMO__);
		let groupBookingsPreselectedTab = accessNested(this.props, 'store.appData.pages.boltShowtimes.data.groupBookings.preselectedTab', BOOK_NOW_TAB);
		// if (groupBookingsPreselectedTab === 'Group Bookings') groupBookingsPreselectedTab = GROUP_BOOKINGS_TAB;
		// if (groupBookingsPreselectedTab === 'Book Now') groupBookingsPreselectedTab = BOOK_NOW_TAB;
		const qs = parseQueryString();
		const selectedTab = qs.groupbookings ? GROUP_BOOKINGS_TAB : qs.booknow ? BOOK_NOW_TAB : groupBookingsPreselectedTab;
		// the date is 2022/07/14 (theater camp)
		const selectedTheaterDate = new Date(Store.get().showtimes.filters?.selected?.date?.[0] || (new Date().getTime() > 1689351754000) ? new Date().getTime() : new Date(1689351754000));
		const formDate = selectedTheaterDate.toISOString().split('T')[0]; /// YYYY-MM-DD

		// group booking hack
		Store.get().set({ groupBookingsShowtimes: selectedTab === GROUP_BOOKINGS_TAB });
		//

		if (!this.logoShade) {
			const secondaryTextColor = styling?.variables?.secondaryTextColor || '#000';
			this.logoShade = lightness(secondaryTextColor) < .5 ? 'light' : 'dark';
		}

		// Group Bookings
		this.initialFormData = this.useGroupBookingsDummyFormData ? getDummyFormDataForGroupBookings(formDate) : { formDate };

		this.state = {
			mode: 'list',
			mapTop: 0,
			mapBottom: 0,
			mapSelectedTheater: null,
			mapTheaterExpanded: false,
			animateTheaterExpansion: false,
			mobileOverlayActive: false,
			socialInterstitial: this.props.store?.limitExceeded,
			validCountry: '',
			ttVisible: true,
			selectedTab: selectedTab,
			formData: { ...this.initialFormData },
			searched: false,
			dateScrollerSticked: false,
			movedDown: false,
		};

		Store.emit('UPDATE_SHOWTIMES_ACTIVE_TAB', selectedTab);

		Store.on('STICK_AND_SCALE', this.stickAndScale);

		Store.on('OPEN_SHOWTIMES_FILTERS', this.showFilterSelection);
	}

	componentDidMount() {
		Store.on('LIMIT_EXCEEDED', this.handleLimitInterstetial);

		const userCountry = accessNested(this.props, 'store.client.geo.countryCode', '').toUpperCase();
		const validCountry = !this.boundingRegions || this.boundingRegions.includes(userCountry);

		if (!this.state.validCountry && !validCountry) {
			const ticketType = this.state.selectedTab === GROUP_BOOKINGS_TAB ? 'groupbookings' : 'tickets';
			Store.emit('WRONG_REGION', userCountry, ticketType);
		} else {
			this.setState({ validCountry });
			this.updateShowtimes();
		}

		document.addEventListener('mousedown', this.onMouseDown);

		if (window.ResizeObserver) {
			this.resizeObserver = new ResizeObserver(() => this.resizeMap());
		}

		this.preventClose = window.location.hash == '#no-clicks-out';

		this.createObservers();

		const qs = parseQueryString();
		if (qs.groupBookingsSubmitted) {
			this.setState({ groupBookingsSubmitted: true, formData: {} });
		}
		this.getPriorityProviderFromQuery(qs);

		const { clientId, enableConversionApi } = accessNested(this.props, 'store.appData.options.metaApi', {});
		if (enableConversionApi) {
			this.metaConversionApi(clientId);
		}
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.onMouseDown);
		this.resizeObserver?.disconnect();
		this.state.observerTheaters?.destroy();
		Store.off('LIMIT_EXCEEDED', this.handleLimitInterstetial);
		Store.off('STICK_AND_SCALE', this.stickAndScale);
		Store.off('OPEN_SHOWTIMES_FILTERS', this.showFilterSelection);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.store.showtimes.data !== this.props.store.showtimes.data) {
			let newSelectedTheater = null;

			if (this.state.mapSelectedTheater) {
				newSelectedTheater = nextProps.store?.showtimes?.data?.find(x => x.id === this.state.mapSelectedTheater.id);
			}
			if (!newSelectedTheater) {
				newSelectedTheater = nextProps.store?.showtimes?.data?.[0];
			}
			if (!newSelectedTheater) {
				this.setState({ mode: 'list', mapSelectedTheater: null });
			} else {
				this.setState({ mapSelectedTheater: newSelectedTheater });
			}
		}

		const isLandscape = nextProps.store?.client.orientation === 'landscape';
		if (this.isDesktop() && isLandscape && this.state.mobileOverlayActive) {
			this.toggleMobileOverlayActive(false);
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.store.client.geo?.countryCode !== this.props.store.client.geo?.countryCode) {
			const userCountry = this.props.store.client.geo.countryCode;
			this.setState({
				validCountry: !this.boundingRegions || this.boundingRegions.includes(userCountry),
				userCountry: userCountry
			});
		}

		if (this.props.store?.showtimes?.filters?.selected !== prevProps.store?.showtimes?.filters?.selected) {
			this.checkFiltersUpdate();
		}

		if (this.props.store?.showtimes.groupBookingsTabActive && this.state.selectedTab !== GROUP_BOOKINGS_TAB) {
			this.setState({ selectedTab: GROUP_BOOKINGS_TAB });
		} else if (this.props.store.showtimes.groupBookingsTabActive === false && this.state.selectedTab !== BOOK_NOW_TAB) {
			this.setState({ selectedTab: BOOK_NOW_TAB });
		}

		const show = this.props.store.showtimes.show;
		const wasShowing = prevProps.store.showtimes.show;


		if (wasShowing && !show) {
			this.setState({ mode: 'list' });
		}

		if (!wasShowing && show) {
			this.getPriorityProviderFromQuery();
		}

		const geo = accessNested(this.props, 'store.client.geo') || {};
		const prevGeo = accessNested(prevProps, 'store.client.geo') || {};
		const countryCode = geo.countryCode;
		const previousCountryCode = prevGeo.countryCode;
		const ticketType = this.state.selectedTab === GROUP_BOOKINGS_TAB ? 'groupbookings' : 'tickets';
		if (countryCode && countryCode !== previousCountryCode) {
			// const appCountry = accessNested(this.props, 'store.appData.meta.region.slug');
			// const sameCountry = (countryCode || '').toLowerCase() === (appCountry || '').toLowerCase();
			const validCountry = !this.boundingRegions || this.boundingRegions.includes(countryCode.toUpperCase());
			if (validCountry !== this.state.validCountry) {
				this.setState({ validCountry });
			}
			if (!validCountry) {
				Store.emit('WRONG_REGION', countryCode, ticketType);
			}
		}

		if (this.$bgVideo && this.state.bgVideo !== prevState.bgVideo) {
			this.$bgVideo.src = this.state.bgVideo;
		}

		if (this.state.filterSelection !== prevState.filterSelection) {
			this.handleScroll();
		}

		if (this.state.mobileOverlayActive && !prevState.mobileOverlayActive) {
			this.focus();
		}

		const lastLoading = accessNested(prevProps, 'store.showtimes.loading');
		const nowLoading = accessNested(this.props, 'store.showtimes.loading');
		const lastError = accessNested(prevProps, 'store.showtimes.error');
		const nowError = accessNested(this.props, 'store.showtimes.error');

		// Should probably not mount gmap in the componentDidUpdate without more checks
		if (this.state.mode === 'map') {
			const userLat = accessNested(this.props, 'store.client.geo.lat');
			const userLon = accessNested(this.props, 'store.client.geo.lon');

			const selectedLat = accessNested(this.state, 'mapSelectedTheater.lat');
			const selectedLon = accessNested(this.state, 'mapSelectedTheater.lon');

			const lat = selectedLon && selectedLat ? selectedLat : userLat;
			const lon = selectedLon && selectedLat ? selectedLon : userLon;
			const zoomControl = this.state.mapTheaterExpanded ? false : true;

			const options = { styles: mapStyles, center: { lat: +lat, lon: +lon }, zoomControl };
			this.mountGoogleMaps(options);

			if (lastLoading && !nowLoading) {
				this.updateMapMarkers();
			}
		} else {
			if (geo.lat !== prevGeo.lat || geo.lon !== prevGeo.lon || (!prevProps.store.showtimes.loading && this.props.store.showtimes.loading)) {
				// On desktop, we scroll $listView rather than $scroller
				const scroller = getComputedStyle(this.$listView).overflow !== 'visible' ? this.$listView : this.$scroller;
				smoothScrollTo(scroller, 0, 100);
			}
		}

		if (nowError && lastError !== nowError) {
			Store.emit('SHOWTIMES_ERROR', ticketType);
		}

		let data = accessNested(this.props, 'store.showtimes.data');

		let prevData = accessNested(prevProps, 'store.showtimes.data');
		if (data !== prevData) {
			this.updateMapMarkers(prevData);
			if (data && !data.length) {
				Store.emit('SHOWTIMES_EMPTY', accessNested(this.props, 'store.client.geo', {}), ticketType);
			}
		}

		this.createObservers();
	}

	selectTab(tab) {
		Store.emit('UPDATE_SHOWTIMES_ACTIVE_TAB', tab, true);
		this.setState({ selectedTab: tab });
		Store.get().set({ groupBookingsShowtimes: tab === GROUP_BOOKINGS_TAB });
		const qs = parseQueryString();
		qs.booknow = tab === BOOK_NOW_TAB ? true : null;
		qs.groupbookings = tab === GROUP_BOOKINGS_TAB ? true : null;
		const newQueryString = toQueryString(qs);
		if (newQueryString !== location.search) {
			history.replaceState(null, '', location.pathname + newQueryString + location.hash);
		}
	}

	getPageId() {
		let show = this.props.store?.showtimes?.show;
		let pageId = typeof show === 'string' && show ? show : this.lastPageId || 'boltShowtimes';
		return this.lastPageId = pageId;
	}

	getPageData() {
		return this.props.showtimesPageData || accessNested(this.props, `store.appData.pages.${this.getPageId()}.data`) || {};
	}

	getPriorityProviderFromQuery(qs) {
		if (!qs) {
			qs = parseQueryString();
		}
		this.setState({ priorityProviderFromQuery: qs.deeplinks });
	}

	onStickedElementRef(el, identifier, onlyOnDesktop) {
		this.stickedElementsRefs[identifier] = { el: el?.base || el, onlyOnDesktop };
	}

	getStickedElements() {
		let { client } = Store.get();
		const stickedElements = Object.values(this.stickedElementsRefs)
			.filter(({ el, onlyOnDesktop }) => !!el && (!onlyOnDesktop || client.isDesktopSize) && (getComputedStyle(el).position !== 'absolute'))
			.map(({ el }) => el);

		stickedElements.sort((a, b) => a.getBoundingClientRect().y - b.getBoundingClientRect().y);
		return stickedElements;

	}

	calculateStickedElementsHeight() {
		return this.getStickedElements().reduce((acc, e) => acc + e.getBoundingClientRect().height, 0);
	}

	calculateMinDistanceToStick() {
		if (!this.$container) {
			return 0;
		}
		let elements = this.getStickedElements();
		let offset = this.$container.getBoundingClientRect().top;
		let minTop = Math.min(...elements.map(e => e.getBoundingClientRect().top - offset));
		return minTop;
	}

	calculateMapPosition() {
		if (!this.$container) {
			return 0;
		}

		if (this.state.mapSelectedTheater && this.state.mapTheaterExpanded) {
			return -1 * this.$container.getBoundingClientRect().top;
		}

		if (!this.$modeSelector) {
			return 0;
		}

		let boundingRect = this.$modeSelector.getBoundingClientRect();
		// The map selector is not visible. This happens on
		// when the map is displayed on the expanded theater view
		if (!boundingRect.height) {
			return this.calculateStickedElementsHeight();
		}
		return boundingRect.top + boundingRect.height - this.$container.getBoundingClientRect().top;
	}

	createObservers() {
		if (this.$container && this.$container !== this.$prevContainer) {
			this.state.observerTheaters?.destroy();
			this.setState({ observerTheaters: this.createObserverTheaters() });
			this.$prevContainer = this.$container;
		}
	}

	createObserverTheaters() {
		return new ReactIntersectionObserver((entries, observer) => {
			if (this.state.mode !== 'list' || !this.$scroller) {
				return;
			}
			const scrollPadding = this.calculateStickedElementsHeight();
			const topEdge = scrollPadding + this.$scroller.getBoundingClientRect().top;
			const [el, props] = observer.getClosestToY(topEdge);
			const [elLast] = observer.getLastVisible();
			const elIsTheater = el && hasClass(el, s.theater);
			const hasScrolled = this.$scroller.scrollTop > 0;
			const hasScrolledToBottom = this.$scroller.scrollTop >= this.$scroller.scrollHeight - this.$scroller.clientHeight;
			const isMoreButton = document.querySelector(`.${s.more}`);
			const isSuggestions = document.querySelector(`.${s.suggestions}`);
			let isMoreTheatersOrSuggestionsVisible = false;
			if (isMoreButton || isSuggestions) {
				const isElementInView = (element) => {
					const rect = element.getBoundingClientRect();
					return rect.top >= 0 && rect.bottom <= window.innerHeight;
				};

				const isMoreButtonVisible = isMoreButton && isElementInView(isMoreButton);
				const isSuggestionsVisible = isSuggestions && isElementInView(isSuggestions);

				isMoreTheatersOrSuggestionsVisible = isMoreButtonVisible || isSuggestionsVisible;
			}

			let dateScrollerSticked = hasScrolled && ((props && elIsTheater) || hasScrolledToBottom || isMoreTheatersOrSuggestionsVisible);
			if (!!this.state.dateScrollerSticked !== dateScrollerSticked) {
				this.setState({ dateScrollerSticked });
			}

			if (this.quickFiltersData?.isSticky && !!this.state.quickFiltersSticky !== !!props) {
				this.setState({ quickFiltersSticky: !!props });
			}

			this.setSelectedTheater(props?.theater || null);

			const isFirstTheater = el && elIsTheater && !el.previousElementSibling?.classList.contains(s.theater);

			const isSnapping = props && props.theater && elLast !== el && !isFirstTheater;
			if (isSnapping) {
				addClass(this.$scroller, s.snappy);
			} else {
				removeClass(this.$scroller, s.snappy);
			}
		}, {
			threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
			repeat: { max: 10, every: 100 }
		});
	}

	onMouseDown(e) {
		if (!this.props.store?.showtimes?.show || e.button !== 0 || this.preventClose || !document.querySelector('.pageWrapper')?.contains(e.target)) {
			return;
		}
		let closestInteractiveElement = e.target.closest('input, button, a');
		if (!e.interactivity && !closestInteractiveElement) {
			this.hideShowtimes();
		}
	}

	isDesktop() {
		return Store.get().client.isDesktopSize;
	}

	onCHTouchStart(e) {
		const touch = (e.touches?.[0] || e);
		this.xDown = touch.clientX;
		this.yDown = touch.clientY;
	}

	onCHTouchMove(e) {
		if (this.xDown == null || this.yDown == null) {
			return;
		}

		const touch = (e.touches?.[0] || e);
		let dx = touch.clientX - this.xDown;
		let dy = touch.clientY - this.yDown;

		// 256 = 16²
		if (dx ** 2 + dy ** 2 > 256) {
			if (dy > 0 && dy > Math.abs(dx)) {
				this.hideShowtimes();
			}
			this.xDown = null;
			this.yDown = null;
		}
	}

	scrollerClick(e) {
		let isDesktop = Store.get().client.isDesktopSize;
		if (e.target === this.$scroller && isDesktop) {
			// Clicked / tapped outside the content
			this.hideShowtimes();
		}
	}

	focus() {
		let input = this.state.mobileOverlayActive ? this.$overlayLocationSearch : this.$locationSearch;
		if (input) {
			input.focus();
		}
	}

	setListMode() {
		let state = this.state;
		if (state.mode === 'list') {
			return;
		}
		this.setState({ mode: 'list' });
		this.clearHeaderAction('backToListMode');
	}

	handleFilterOverlayClick(e) {
		if (e.target !== this.$filterSelection.base && !this.$filterSelection.base.contains(e.target)) {
			// this.cancelFilterSelection();
			this.hideFilterSelection();
		}
	}

	handleScroll(e) {
		const distanceScrolled = e?.target?.scrollTop || 0;
		const ttThreshold = window.innerWidth / 16 * 9 / 2;
		const newTTVisible = distanceScrolled <= ttThreshold;
		const { ttVisible } = this.state;

		if (newTTVisible !== ttVisible) {
			this.setState({ ttVisible: newTTVisible });
		}
	}

	toggleMoveDown() {
		this.setState({ movedDown: !this.state.movedDown });
	}

	toggleMobileOverlayActive(newState) {
		if (typeof newState !== 'boolean') {
			newState = !this.state.mobileOverlayActive;
		}
		if (newState === this.state.mobileOverlayActive) {
			return;
		}
		this.setState({ mobileOverlayActive: newState });

		if (newState) {
			Store.emit('SHOWTIMES_SEARCH_OVERLAY_SHOW');
			Store.emit('SET_HEADER_ACTION', {
				icon: 'back',
				action: () => {
					this.setState({ mobileOverlayActive: !this.state.mobileOverlayActive });
					Store.emit('SHOWTIMES_SEARCH_OVERLAY_HIDE');
				},
				// dark: true,
				// style: { color: '#0d0d0d' },
				tag: 'hideShowtimesSearchOverlay'
			});
		} else {
			Store.emit('REMOVE_HEADER_ACTIONS', 'hideShowtimesSearchOverlay');
		}
	}

	trackConversion(theater, screening, provider, mode, url) {
		if (!theater || !screening) {
			return;
		}

		let format = screening.format.trim() === '' ? 'absent' : screening.format;
		let screeningMovie = screening.movie?.regions?.find(m => m.country === 'INTL');

		const useMovieName = Store.get().appData.options?.movieNameInTicketConversion;
		let conversion = [
			theater.name,
			accessNested(theater, 'chain.name'),
			screening.date,
			screening.time,
			format,
			provider,
			useMovieName && screeningMovie?.slug,
			this.isMultiMovie && getMovieName(screening?.movie?.id)
		].filter(e => e).join('_');

		if (conversion.split('').length > 150) {
			conversion = [
				theater.name.substring(0, 50),
				accessNested(theater, 'chain.name'),
				screening.date,
				screening.time,
				format,
				provider,
				useMovieName && screeningMovie?.slug,
				this.isMultiMovie && getMovieName(screening?.movie?.id)
			].filter(e => e).join('_').slice(0, 150);
		}

		Store.emit('TICKET_CONVERSION', {
			screening,
			theater,
			date: screening.date,
			time: screening.time,
			format: format,
			provider,
			conversion,
			source: theaterModeToSource[mode] || 'listings_view',
			theaterName: theater.name,
			day: formatDateTime(parseDate(screening.date), 'dddd'),
			url,
			movieTitle: screeningMovie?.title,
			movieSlug: screeningMovie?.slug,
			ticketType: this.state.selectedTab === GROUP_BOOKINGS_TAB ? 'groupbookings' : 'tickets'
		});
	}

	setMapMode() {
		let state = this.state;
		if (state.mode === 'map') {
			return;
		}
		if (!this.$content || !this.$scroller) {
			return;
		}

		const isDesktopSize = this.isDesktop();
		let scrollDistance = 0;

		if (!isDesktopSize) {
			const distanceToMakeItSticked = this.calculateMinDistanceToStick();
			let currentTop = this.$scroller.scrollTop;
			scrollDistance = distanceToMakeItSticked + currentTop;
			this.$scroller.style.maxHeight = `${this.calculateStickedElementsHeight()}px`;
		}

		if (scrollDistance) {
			setTimeout(() => this.$scroller.scrollTop = scrollDistance, 0);
		}
		this.setState({ mode: 'map' });

		const nearbyFromChain = this.props.store?.showtimes?.nearby?.chain;
		const selectedTheater = state.mapSelectedTheater;
		if (selectedTheater && nearbyFromChain?.theater !== selectedTheater.id) {
			Store.emit('GET_NEARBY_CINEMAS_FROM_CHAIN', selectedTheater);
		}
	}

	setMapModeButton() {
		let state = this.state;
		if (state.mode === 'map') {
			return;
		}
		if (state.mapSelectedTheater) {
			this.setSelectedTheater(state.mapSelectedTheater);
		}
		this.setState({ mapTheaterExpanded: false, animateTheaterExpansion: false });
		this.setMapMode();
		this.setHeaderAction({
			icon: 'back',
			action: this.setListMode,
			tag: 'backToListMode'
		});
		this.updateMapMarkers();
	}

	showFilterSelection() {
		const isDesktopSize = this.isDesktop();

		this.setState({ filterSelection: true });
		Store.emit('TOGGLE_INTERSTITIAL_OPEN', true);

		if (!this.$collapseHeader || !this.$content || !this.$filterSelection) {
			return;
		}

		// 156 = margin-top of .content
		if (!isDesktopSize && this.$scroller.scrollTop < 156) {
			this.$scroller.scrollTop = 156;
		}
	}

	hideFilterSelection() {
		Store.emit('TOGGLE_INTERSTITIAL_OPEN', false);
		this.setState({ filterSelection: false });
	}

	getDefaultAction() {
		let mode = this.state.mode;
		return {
			icon: 'back',
			action: () => {
				this.setState({ mapTheaterExpanded: mode !== 'list' && mode !== 'map' ? true : false, mode });
				// this.updateMapMarkers();
				this.updateMapOptions({ zoomControl: true });
			}
		};
	}

	getCurrentShowtimesBtnAction() {
		const actions = accessNested(Store.get(), 'showtimes.actions');
		return actions[actions.length - 1] || this.getDefaultAction();
	}

	getCurrentHeaderAction() {
		const actions = accessNested(Store.get(), 'header.actions');
		return actions[actions.length - 1] || this.getDefaultAction();
	}

	setHeaderAction(action) {
		const storeEvent = this.props?.store?.client?.deviceSize === 'mobile' ? 'SET_HEADER_ACTION' : 'SET_SHOWTIMES_BTN_ACTIONS';
		Store.emit(storeEvent, action);
	}

	clearHeaderAction(tag) {
		const storeEvent = this.props?.store?.client?.deviceSize === 'mobile' ? 'REMOVE_HEADER_ACTIONS' : 'REMOVE_SHOWTIMES_BTN_ACTIONS';
		Store.emit(storeEvent, tag);
	}

	triggerShowtimesBtn() {
		if (!this.state.mapTheaterExpanded) return;
		Store.emit('POP_SHOWTIMES_BTN_ACTION');
		let actionData = this.getCurrentShowtimesBtnAction();
		if (typeof actionData.action === 'function') {
			actionData.action();
		} else if (typeof actionData.action === 'string') {
			Store.emit(actionData.action);
		}
	}

	triggerHeaderAction() {
		let actionData = this.getCurrentHeaderAction();
		if (typeof actionData.action === 'function') {
			actionData.action();
		} else if (typeof actionData.action === 'string') {
			Store.emit(actionData.action);
		}
		Store.emit('POP_HEADER_ACTION');
	}

	setSelectedTheater(theater) {
		this.setState({ selectedTheater: theater });
	}

	getTheaterScrollerDisplayedDates() {
		const screeningsDates = this.state.selectedTheater?.screeningsDates || [];
		const formattedScreeningsDates = screeningsDates.map(date => new Date(date).toISOString().slice(0, 10));
		let defaultToday = [formatDateTime(new Date(), 'yyyy-MM-dd')];
		let selectedDate = accessNested(this.props.store.showtimes, 'filters.selected.date', defaultToday);
		return { available: formattedScreeningsDates, selected: selectedDate };
	}

	getDisplayedDates() {
		let defaultToday = [formatDateTime(new Date(), 'yyyy-MM-dd')];
		let selectedTheater = this.state.selectedTheater;

		let filters = this.props.store.showtimes.filters;
		let selectedDate = accessNested(this.props.store.showtimes, 'filters.selected.date', defaultToday);
		let theatersDates = this.props.store.showtimes.theatersDates || {};

		if (!filters || filters.loading) {
			return {
				available: defaultToday,
				selected: selectedDate,
				loading: true
			};
		}
		if (!(filters.available?.date?.length)) {
			return {
				available: defaultToday,
				selected: selectedDate,
			};
		}
		if (!selectedTheater || !this.state.dateScrollerSticked) {
			return {
				available: filters.available.date,
				selected: selectedDate,
			};
		}
		let activeDates = theatersDates[selectedTheater.id] && Array.isArray(theatersDates[selectedTheater.id])
			? theatersDates[selectedTheater.id]
			: null;

		return {
			available: filters.available.date,
			active: activeDates,
			loading: !activeDates,
			selected: selectedDate
		};
	}

	expandTheater(theater) {
		Store.emit('UPDATE_API_KEY');
		Store.emit('GET_NEARBY_CINEMAS_FROM_CHAIN', theater || this.state.mapSelectedTheater);
		Store.emit('IN_CINEMA_DETAIL_VIEW', theater);

		let sourceMode = this.state.mode;

		const newTheater = theater || this.state.mapSelectedTheater;
		const ticketType = this.state.selectedTab === GROUP_BOOKINGS_TAB ? 'groupbookings' : 'tickets';
		Store.emit('SELECT_THEATER', newTheater, sourceMode, ticketType);

		this.setSelectedTheater(newTheater);

		let newState = { mapTheaterExpanded: true, animateTheaterExpansion: sourceMode === 'map' };
		if (theater) {
			newState.mapSelectedTheater = theater;
		}

		this.setState(newState);
		this.setMapMode();
		this.updateMapMarkers();
		this.updateMapOptions({ zoomControl: false });
		this.setHeaderAction({
			icon: 'back',
			action: () => this.collapseTheater(sourceMode),
			tag: 'collapseTheater'
		});
	}

	collapseOnMapClick(e) {
		e?.stopPropagation();
		this.collapseTheater('map');
	}

	collapseTheater(backMode = 'map') {
		this.setState({ mapTheaterExpanded: false, mode: backMode });
		this.clearHeaderAction('collapseTheater');
	}

	expandTheaterEventInquiry(theater) {
		const newTheater = theater;
		Store.emit('GROUP_BOOKINGS_INQUIRE', newTheater);
		this.setSelectedTheater(newTheater);
		if (this.state.mode !== 'eventInquiry') {
			this.setState({ mode: 'eventInquiry' });
			this.setHeaderAction({
				icon: 'close',
				action: this.exitEventInquiry,
				tag: 'closeEventInquiry'
			});
		}
	}

	exitCinemaDetailView(sourceMode) {
		this.setState({ mapTheaterExpanded: sourceMode !== 'list' && sourceMode !== 'map' ? false : true, mode: sourceMode });
		this.updateMapMarkers();
		this.updateMapOptions({ zoomControl: true });
		Store.emit('EXIT_CINEMA_DETAIL_VIEW');
	}

	filtersChange() {
		Store.emit('UPDATE_API_KEY');
		this.hideFilterSelection();

		const isDesktopSize = this.isDesktop();
		if (isDesktopSize) {
			Store.emit('POP_SHOWTIMES_BTN_ACTION');
			return;
		}
		Store.emit('POP_HEADER_ACTION');
	}

	checkFiltersUpdate() {
		let filters = accessNested(this.props, 'store.showtimes.filters.selected') || {};
		const snapshot = this.filtersSnapshot;
		this.filtersSnapshot = filters;

		// Remove from query string (SUP-598)
		let qs = parseQueryString();
		let hasChanges = Object.keys(filters).some(filter => {
			if (!qs[filter] || typeof qs[filter] !== 'string') {
				return;
			}
			let value = filters[filter];
			if (!Array.isArray(value)) {
				value = [value];
			}
			const qsList = commaSeparatedList(qs[filter]);
			if (filter === 'format' && filters.audioDetails?.includes('Dolby Cinema')) {
				const dolbyRequests = qsList.filter(e => e.toLowerCase().includes('dolby'));
				value = value.concat(dolbyRequests);
			}
			let newValue = qsList.filter(e => value.includes(e)).join(',');
			if (newValue === qs[filter]) {
				return;
			}
			qs[filter] = newValue || null;
			return true;
		});
		if (hasChanges) {
			let newUrl = location.pathname + toQueryString(qs) + location.hash;
			history.replaceState({ activePage: Store.get().activePage }, '', newUrl);
		}

		const hasChanged = prop => !isShallowEqual((filters[prop] || []).slice().sort(), (snapshot[prop] || []).slice().sort());
		const dateChanged = hasChanged('date');
		const timeChanged = hasChanged('time');
		const formatChanged = hasChanged('format');
		const languageChanged = hasChanged('language');
		const subtitleChanged = hasChanged('subtitles');
		const anyFilterChange = JSON.stringify(filters) !== JSON.stringify(snapshot);

		if (anyFilterChange) {
			// Should we also put the tracking in the store listeners and remove this change check completely ?
			Store.emit('TRACK_FILTERS_CHANGE', filters);
		}

		const ticketType = this.state.selectedTab === GROUP_BOOKINGS_TAB ? 'groupbookings' : 'tickets';

		if (dateChanged) {
			Store.emit('FILTER_SELECTED_DAY', filters.date[0], ticketType);
			if (ticketType === 'groupbookings') {
				this.updateGroupBookingsFormData('formDate', filters.date[0]);
			}
		}
		if (timeChanged) {
			Store.emit('FILTER_SELECTED_TIME', filters.time.join(','), ticketType);
		}
		if (formatChanged) {
			Store.emit('FILTER_SELECTED_FORMAT', filters.format.join(','), ticketType);
		}
		if (languageChanged) {
			Store.emit('FILTER_SELECTED_LANGUAGE', filters.language.join(','), ticketType);
		}
		if (subtitleChanged) {
			Store.emit('FILTER_SELECTED_SUBTITLES', filters.subtitles.join(','), ticketType);
		}
	}

	renderDummyElements(count) {
		if (!this.state.validCountry) {
			return;
		}
		return [...Array(count)].map((e, i) => (
			<div class={s.dummy} key={i}>
				<div class={s.titleLine}>
					<div class={s.icon} />
					<div class={s.title} />
				</div>
				<div class={s.screenings}>
					<div class={s.screening} />
					<div class={s.screening} />
					<div class={s.screening} />
					<div class={s.screening} />
				</div>
			</div>
		));
	}

	filterValue(filter, value) {
		if (filter === 'date') {
			let parts = value.split('-');
			let date = new Date(+parts[0], parts[1] - 1, +parts[2]);
			const dateTimeLocale = accessNested(this.props, 'store.appData.copy.baseCopy.$DATETIME_LOCALE');
			let formattedDate = formatDateTime(date, 'dd MMM', dateTimeLocale);
			if (formattedDate === this.today) {
				const today = accessNested(this.props, 'store.appData.copy.baseCopy.$TODAY', 'today');
				return today.charAt(0).toUpperCase() + today.slice(1);
			}
			return formattedDate;
		}
		return accessNested(this.props, ['store', 'appData', 'copy', 'baseCopy', 'filters', filter, value]) || value;
	}

	mountGoogleMaps(options) {
		if (this.mapDisabled || this.gmap || !this.$mapElement) {
			return;
		}
		const mapUtils = this.useMapTiler ? mapTilerUtils : gmapsUtils;
		this.gmap = mapUtils.mount(this.$mapElement, options);

		if (this.resizeObserver) {
			this.resizeObserver.observe(this.$mapElement);
		}
		this.updateMapMarkers();
	}

	async resizeMap() {
		const map = await this.gmap;
		map?.resize?.();
	}

	hideShowtimes() {
		const isSinglePageIframed = getIsSinglePageIframed();
		if (this.noHome || isSinglePageIframed) return;

		const isDesktopSize = this.isDesktop();
		const action = isDesktopSize ? this.triggerShowtimesBtn : this.triggerHeaderAction;
		action();
		this.hideFilterSelection();
		this.setState({ mode: 'list' });
		Store.emit('SHOWTIMES_HIDE', true, true);
	}

	showMore() {
		Store.emit('SHOWTIMES_SHOW_MORE');
	}

	async updateMapOptions(opts) {
		if (!this.gmap && typeof opts === 'object') {
			return;
		}

		let gmap = await this.gmap;
		if (gmap.setOptions) {
			gmap.setOptions(opts);
		}
	}

	async updateMapMarkers(previousTheaters) {
		if (!this.gmap) {
			return;
		}
		const sharedImageRoot = accessNested(this.props, 'store.appData.urls.roots.sharedImages');
		// const expanded = this.state.mapTheaterExpanded;
		let gmap = await this.gmap;

		let data = accessNested(this.props, 'store.showtimes.data') || [];
		if (!data || previousTheaters) {
			return;
		}
		if (this.mapMarkers) {
			this.mapMarkers.forEach(marker => marker.setMap(null));
		}

		// if (expanded) {
		// 	data = data.filter(e => this.state.mapSelectedTheater.id === e.id);
		// }

		let defaultActiveShade = 'light';

		const variableWhite = accessNested(this.props, 'store.appData.styling.variables.white');
		const variableScreeningBtnTxtColor = accessNested(this.props, 'store.appData.styling.variables.screeningBtnTxtColor');

		if (variableWhite === variableScreeningBtnTxtColor) {
			defaultActiveShade = 'dark';
		}

		const activeShade = accessNested(this.props, 'store.appData.styling.variables.activeMapMarkerShade', defaultActiveShade);
		const markerCreator = this.useMapTiler ? createMapTilerMarker : createMarker;

		this.mapMarkers = await Promise.all(data.map(theater => {
			const isActive = this.state.mapSelectedTheater.id === theater.id;
			const logo = theater.chain.logo || this.defaultChainLogo;
			const activeLogoLink = `${sharedImageRoot}/logos/${activeShade}/${logo}`;
			const inactiveLogoLink = `${sharedImageRoot}/logos/dark/${logo}`;

			return markerCreator({
				position: { lat: theater.lat, lon: theater.lon },
				activeLogoLink,
				inactiveLogoLink,
				onClick: (marker) => this.updateMapSelectedTheater(theater, marker),
				isActive
			}, gmap);
		}));

		const centrSettings = {};
		const { geo } = Store.get().client;
		if (this.state.mapSelectedTheater) {
			centrSettings.lat = accessNested(this.state, 'mapSelectedTheater.lat');
			centrSettings.lng = accessNested(this.state, 'mapSelectedTheater.lon');
		} else if (geo) {
			centrSettings.lat = accessNested(geo, 'lat');
			centrSettings.lng = accessNested(geo, 'lon');
		}

		if (Object.keys(centrSettings).length) {
			gmap.setCenter(centrSettings);
		}
	}

	selectNearby(selection) {
		const ticketType = this.state.selectedTab === GROUP_BOOKINGS_TAB ? 'groupbookings' : 'tickets';
		Store.emit('SET_USER_LOCATION', selection, 'nearby', ticketType);
	}
	selectNearbyFromChain(theater) {
		this.expandTheater(theater);
	}

	setDirections(travelMode) {
		const { mapSelectedTheater } = this.state;

		const destLat = mapSelectedTheater.lat;
		const destLng = mapSelectedTheater.lon;

		if (destLat && destLng) {
			const link = `https://www.google.com/maps/dir/?api=1&destination=${destLat},${destLng}&travelmode=${travelMode.toLowerCase()}`;
			Store.emit('MAP_REQUEST_DIRECTIONS', travelMode);
			window.open(link);
		}
	}

	updateMapSelectedTheater(theater, marker) {
		this.setState({ mapSelectedTheater: theater });
		this.mapMarkers.forEach(marker => {
			if (marker.isActive) {
				marker.makeInactive();
			}
		});
		marker.makeActive();
		this.updateMapMarkers();
	}

	async setGeo() {
		const data = await geoFromIP();
		const ticketType = this.state.selectedTab === GROUP_BOOKINGS_TAB ? 'groupbookings' : 'tickets';
		Store.emit('GEO_FROM_IP', data, ticketType);
		this.setState({ geoFromIP: data });
	}

	handleLimitInterstetial(isExceeded) {
		if (this.state.socialInterstitial === isExceeded) {
			return;
		}
		this.setState({ socialInterstitial: isExceeded });
	}

	// Done in getBaseFilters (utils/showtimesLoader)
	// applyQueryStringMovieFilter() {
	// 	const queryString = parseQueryString();
	// 	if (!queryString.m) return;
	// 	const queryStringMovieIds = queryString.m.replace(/\s+/g, '').replace('%20', '').split(',');
	// 	Store.emit('SET_FILTERS_SELECTED_MOVIE_ID', queryStringMovieIds);
	// 	Store.emit('SHOWTIMES_REFRESH');

	// 	// with clear query string
	// 	history.replaceState && history.replaceState(null, '', location.pathname);
	// }

	async updateShowtimes() {
		await this.setGeo();
		if (this.getPageData().useV2) {
			Store.emit('SHOWTIMES_REFRESH');
		} else {
			Store.emit('FILTERS_REFRESH', { forceShowtimesRefresh: true });
		}
	}

	stickAndScale(percentage) {
		const { onesheetDisabled, isWidget } = this.props;
		const { isDesktopSize } = this.props.store.client;
		const dualViewEnabled = isDualViewEnabled(this.props.pages);

		if (isDesktopSize) {
			const maxLeft = onesheetDisabled ? 0 : (window.innerHeight * 609 / 900);
			const left = maxLeft * percentage;
			this.$container.style.left = left + 'px';
			this.$container.style.top = '0px';
		} else {
			const maxTop = 64;
			const top = maxTop * percentage;
			this.$container.style.left = '0px';
			this.$container.style.top = top + 'px';
			this.$content.style.top = (dualViewEnabled ? 0 : (16 - (percentage * 16))) + 'px';
			this.$container.style.borderRadius = `${20 - (20 * percentage)}px`;
			this.$container.style.overflow = 'hidden';
		}
	}

	updateGroupBookingsFormData(id, value) {
		this.setState(state => {
			state.formData = { ...state.formData, [id]: value };
			return state;
		});
	}

	replaceGroupBookingsQueryString(str) {
		return str.replace(/([?&])(?:booknow|groupbookings)(?:=[^&#]*)?(&|$)/i, (m, sep, rest) => rest ? sep : '');
	}

	exitEventInquiry(type) {
		const currentFormData = this.state.formData;
		if (type === 'preserveData') {
			this.setState({ formData: { ...currentFormData, currentStage: '' }, mode: 'list' });
			Store.get().set({ groupBookingsShowtimes: false });
			return;
		}

		const formDataReset = {
			...this.initialFormData,
		};

		const selectedDates = this.props.store?.showtimes?.filters?.selected?.date || [];

		if (selectedDates.length > 0) {
			formDataReset.formDate = selectedDates[0];
		}

		this.setState({ formData: this.useGroupBookingsDummyFormData ? currentFormData : formDataReset, mode: 'list' });
		this.clearHeaderAction('closeEventInquiry');
	}

	renderGroupBookingSubmitted() {
		const data = { content: 'The theater will be in touch soon!', title: 'Inquiry Sent', buttonTooltip: 'Back to theater listing' };

		const clearQueryString = () => {
			const qs = parseQueryString();
			if (qs.groupBookingsSubmitted) {
				window.history.replaceState('', '', window.location.origin + window.location.pathname);
			}
		};

		return (
			<Tooltip
				ref={ref => this.$tooltip = ref?.base}
				class={joinClasses(s.submittedOverlay, s.confirmationOverlay)}
				data={data}
				isMobile
				isOpen
				position={'topRight'}
				onHide={clearQueryString}
				icon={(
					<div class={s.formSubmissionIcon}>
						<svg width="35" height="33" viewBox="0 0 35 33" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M18.89 30H5C4.33696 30 3.70107 29.7366 3.23223 29.2678C2.76339 28.7989 2.5 28.163 2.5 27.5V11.5H32.5V16.39C33.4386 16.9378 34.2828 17.6334 35 18.45V5C35 3.67392 34.4732 2.40215 33.5355 1.46447C32.5979 0.526784 31.3261 0 30 0L5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5L0 27.5C0 28.8261 0.526784 30.0979 1.46447 31.0355C2.40215 31.9732 3.67392 32.5 5 32.5H21C20.1656 31.7867 19.4529 30.9424 18.89 30ZM10 2.5H30C30.663 2.5 31.2989 2.76339 31.7678 3.23223C32.2366 3.70107 32.5 4.33696 32.5 5V9H2.5V5C2.5 4.33696 2.76339 3.70107 3.23223 3.23223C3.70107 2.76339 4.33696 2.5 5 2.5H10Z" fill="black" fill-opacity="0.3" />
						</svg>
						<svg class={s.secondaryIcon} width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M3.59958 8.79067L1.19877 6.26339C0.933745 5.98406 0.933745 5.53141 1.19877 5.25274C1.46379 4.97342 1.89382 4.97342 2.15884 5.25274L4.07962 7.27604L9.84069 1.2095C10.1063 0.930168 10.5364 0.930168 10.8008 1.2095C11.0664 1.48882 11.0664 1.94281 10.8008 2.22147L4.55965 8.79067C4.42714 8.93 4.25338 9 4.07962 9C3.90585 9 3.73209 8.93 3.59958 8.79067Z" fill="black" />
							<path d="M3.59958 8.79067L1.19877 6.26339C0.933745 5.98406 0.933745 5.53141 1.19877 5.25274C1.46379 4.97342 1.89382 4.97342 2.15884 5.25274L4.07962 7.27604L9.84069 1.2095C10.1063 0.930168 10.5364 0.930168 10.8008 1.2095C11.0664 1.48882 11.0664 1.94281 10.8008 2.22147L4.55965 8.79067C4.42714 8.93 4.25338 9 4.07962 9C3.90585 9 3.73209 8.93 3.59958 8.79067" stroke="black" />
						</svg>
					</div>
				)
				}
			/>
		);
	}

	renderCurrentFilters() {
		const { validCountry } = this.state;
		// For some reason that breaks the map view
		// Hide it with display none for now
		// if (!validCountry) {
		// 	return;
		// }
		const accessibilityCopy = accessNested(this.props, 'store.appData.copy.accessibilityCopy', {});
		const loading = accessNested(this.props, 'store.showtimes.loading') || false;
		let disabled = loading;

		let filters = accessNested(this.props, 'store.showtimes.filters') || {};
		let selected = filters.selected || {};

		let buttons = this.filtersList.map(filter => {
			let sel = selected[filter] || [];
			let label;
			if (sel.length) {
				label = sel.map(v => this.filterValue(filter, v)).join(', ');
			} else {
				label = accessNested(this.props, ['store', 'appData', 'copy', 'baseCopy', 'filters', filter, '_all']);
			}
			if (!label) {
				return;
			}
			let filterBtnAria;

			if (filter === 'date') {
				filterBtnAria = accessibilityCopy.$DAY_FILTER_ARIA;
			}
			if (filter === 'time') {
				filterBtnAria = accessibilityCopy.$TIME_FILTER_ARIA;
			}
			if (filter === 'format') {
				filterBtnAria = accessibilityCopy.$FORMAT_FILTER_ARIA;
			}
			return (
				<Button class={joinClasses(s.filter, s[filter])} trigger={this.showFilterSelection} disabled={disabled} ariaLabel={filterBtnAria.replace('<option>', label)}>{label}</Button>
			);
		});
		let hidden = !validCountry || this.state.socialInterstitial || this.noFiltersAvailable;
		return (
			<div class={joinClasses(s.filters, hidden && s.hidden)} ref={e => this.$filters = e} key="currentFilters">
				<Button class={joinClasses(s.filter, s.toggle)} trigger={this.showFilterSelection} disabled={disabled} ariaLabel={accessibilityCopy.$OPEN_FILTER_OPTIONS_ARIA}><IconFilter class={s.filterIcon} ariaLabel={accessibilityCopy.$OPEN_FILTER_OPTIONS_ARIA} /></Button>
				{buttons}
				<div class={s.spacer} />
			</div>
		);
	}

	renderModeSelector(inListOrMapView) {
		const loading = accessNested(this.props, 'store.showtimes.loading');
		const fontStyles = accessNested(this.props, 'store.appData.styling.fontVariables');
		const { mode, mapSelectedTheater, mapTheaterExpanded } = this.state;
		let copy = accessNested(this.props, 'store.appData.copy', {});

		let icons = <LoadIcon />;

		if (!loading) {
			let setListMode = this.setListMode;
			// Need to use the menu back arrow to go back
			if (mapTheaterExpanded && mapSelectedTheater) {
				setListMode = undefined;
			}
			const customMapIcon = accessNested(this.props, 'store.appData.styling.imageVariables.showtimesMapViewIcon', '');
			icons = [
				<Button class={joinClasses({ s, listIcon: true, active: (mode === 'list' && loading === false) })} trigger={setListMode} ariaLabel={copy.accessibilityCopy.$LIST_VIEW_ARIA}>
					<IconList />
				</Button>,
				<Button class={joinClasses({ s, mapIcon: true, active: mode === 'map', custom: customMapIcon })} trigger={this.setMapModeButton} ariaLabel={copy.accessibilityCopy.$MAP_VIEW_ARIA}>
					{customMapIcon ? <div class={s.customMapIcon} style={`-webkit-mask: url(${customMapIcon}) no-repeat center;`} /> : <IconMap />}
				</Button>
			];
		}

		let ctaText = copy.baseCopy.$SELECT_A_SHOWTIME;
		if (loading) {
			ctaText = copy.baseCopy.$LOADING_CINEMAS;
		} else if (!(accessNested(this.props, 'store.showtimes.data') || []).length) {
			ctaText = '';
		} else if (mode === 'map') {
			ctaText = copy.baseCopy.$SELECT_A_CINEMA;
		}

		const pageData = getShowtimesData() || {};

		const quotesCarousel = pageData.quotesCarousel;
		const quotesCarouselAllowedRegions = (quotesCarousel?.regions || '').split(',').map(a => a.trim()).filter(a => a);
		const clientRegion = this.props.store?.client?.geo?.countryCode;
		const hasQuotesCarousel = quotesCarousel && (quotesCarouselAllowedRegions.length < 1 || quotesCarouselAllowedRegions.includes(clientRegion));

		const notificationBannerData = pageData.notificationBanner || {};
		const activeNotificationBanners = Object.entries(notificationBannerData).filter(([, banner]) => {
			if (!banner) return false;
			if (banner.tabs) {
				return asList(banner.tabs).some(tab => {
					if (tab === 'group-bookings') tab = GROUP_BOOKINGS_TAB;
					if (tab === 'tickets') tab = BOOK_NOW_TAB;
					return !tab || tab === this.state.selectedTab;
				});
			}
			if (this.state.selectedTab === GROUP_BOOKINGS_TAB && !pageData.groupBookings?.displayNotificationBanner) {
				return false;
			}
			return true;
		});
		const showNotificationBanner = activeNotificationBanners.length > 0;

		return (
			<div class={s.modeWrapper}>
				{showNotificationBanner && (
					<NotificationBannerWithIntersectionObserver
						banners={Object.fromEntries(activeNotificationBanners)}
						isShowtimes
						region={this.props.store?.client?.geo?.countryCode}
						movies={this.props.store?.showtimes?.movies}
						intersectionObserver={this.state.observerTheaters}
						// which mode the user is viewing
						listOrMapMode={mode}
						// which container (list or map) this instance of Notif Banner is rendered in
						inListOrMapView={inListOrMapView}
						key="showtimesNotificationBanner"
					/>
				)}

				{hasQuotesCarousel && (
					<QuotesCarouselWithIntersectionObserver
						data={quotesCarousel}
						client={this.props.store?.client}
						isShowtimes
					/>
				)}
				<div class={s.mode}>
					<div class={joinClasses(s.cta, fontStyles.showtimesLoading)}>
						{ctaText}
					</div>
					<div class={s.icons}>
						{icons}
					</div>
				</div>
			</div>
		);
	}

	renderElements() {
		const state = this.state;
		if (!state.validCountry) {
			return;
		}
		const data = accessNested(this.props, 'store.showtimes.data', []);
		const showtimesAppData = this.getPageData();
		// const error = accessNested(this.props, 'store.showtimes.error');
		const hasMore = accessNested(this.props, 'store.showtimes.more', false);
		const loadingMore = accessNested(this.props, 'store.showtimes.loadingMore') || false;
		const copy = accessNested(this.props, 'store.appData.copy');
		const clientGeo = accessNested(this.props, 'store.client.geo', {});
		const sharedImageRoot = accessNested(this.props, 'store.appData.urls.roots.sharedImages', '');
		const fontStyles = accessNested(this.props, 'store.appData.styling.fontVariables');
		const showtimesFilters = accessNested(this.props, 'store.showtimes.filters');
		const theatersDates = accessNested(this.props, 'store.showtimes.theatersDates', {});
		const groupBookings = accessNested(this.props, 'store.appData.pages.boltShowtimes.data.groupBookings', {});

		const elements = data.map((theater, i) => (
			<TheaterWithIntersectionObserver
				class={s.theater}
				theater={theater}
				showtimesFilters={showtimesFilters}
				mode="list"
				clientGeo={clientGeo}
				geoFromIP={state.geoFromIP || {}}
				onExpandClick={!this.mapDisabled && (() => this.expandTheater(theater))}
				eventInquiryTrigger={() => this.expandTheaterEventInquiry(theater)}
				sharedImageRoot={sharedImageRoot}
				logoShade={this.logoShade}
				copy={copy}
				showtimesAppData={showtimesAppData}
				key={'theater-' + theater.id + i}
				showFilterSelection={this.showFilterSelection}
				trackConversion={this.trackConversion}
				intersectionObserver={this.state.observerTheaters}
				loading={theatersDates[theater.id] === 'loading'}
				divideScreeningsByAttributes
				groupBookings={this.state.selectedTab === GROUP_BOOKINGS_TAB ? groupBookings : {}}
				ticketType={this.state.selectedTab === GROUP_BOOKINGS_TAB ? 'groupbookings' : 'tickets'}
				priorityProviderFromQuery={this.state.priorityProviderFromQuery}
				isMultiMovie={this.isMultiMovie}
			/>
		));
		if (hasMore) {
			elements.push(
				<div class={s.more} key="more">
					<Button class={joinClasses(s.moreButton, loadingMore && s.loadingMore, fontStyles.showtimesShowMore)} trigger={this.showMore} ariaLabel={copy.accessibilityCopy.$MORE_CINEMAS_BTN_ARIA}>
						{loadingMore ? <LoadIcon class={s.loadingMoreIcon} /> : copy.baseCopy.$SHOW_MORE_CINEMAS}
					</Button>
				</div>
			);
		}
		return elements;
	}

	renderNearby(storeData, cta, buttonText, buttonsAria, buttonAction, count) {
		const { data, loading, error } = storeData;
		const fontStyles = accessNested(this.props, 'store.appData.styling.fontVariables');
		const clientGeo = accessNested(this.props, 'store.client.geo', {});
		const currentGeo = clientGeo && new Geo({ lat: clientGeo.lat, lon: clientGeo.lon });
		const distanceUnit = this.getPageData().theaterDistanceUnit || 'km';

		if (!this.state.validCountry || error || (!loading && !data?.length)) {
			return;
		}

		let content;
		if (loading) {
			content = Array(6).fill(<div class={s.nearbyTheaterDummy} />);
		} else {
			content = data.slice(0, count).map(element => {
				const distance = currentGeo.distanceFrom(element, distanceUnit, 1);

				return (
					<Button
						class={s.nearbyTheater}
						trigger={() => buttonAction(element)}
						ariaLabel={buttonsAria.replace('<cinema>', element.name).replace('<city>', element.city)}
						key={element.id}
					>
						<span class={s.nearbyName}>{element[buttonText]}</span>
						<span class={s.nearbyDistance}>{`${distance}${distanceUnit}`}</span>
					</Button>
				);
			});
		}

		return (
			<div class={s.nearby}>
				<div class={joinClasses(s.cta, fontStyles.moreShowtimes)}>{cta}</div>
				<div class={s.nearbyList}>{content}</div>
			</div>
		);
	}

	renderNearbyFromChain() {
		let storeData = accessNested(this.props, 'store.showtimes.nearby.chain') || {};
		let cta = accessNested(this.props, 'store.appData.copy.baseCopy.$MORE_SHOWTIMES_CINEMAS') || 'More cinemas from the same chain';
		let aria = accessNested(this.props, 'store.appData.copy.accessibilityCopy.$CINEMAS_SAME_CHAIN_BTN_ARIA') || '';
		return this.renderNearby(storeData, cta, 'name', aria, this.selectNearbyFromChain, 10);
	}
	renderNearbyScreeningsLocations() {
		let storeData = accessNested(this.props, 'store.showtimes.nearby.locations') || {};
		let cta = accessNested(this.props, 'store.appData.copy.baseCopy.$MORE_SHOWTIMES_LOCATIONS') || 'More showtimes found in these locations';
		let aria = accessNested(this.props, 'store.appData.copy.accessibilityCopy.$OTHER_LOCATIONS_BTN_ARIA') || '';
		return this.renderNearby(storeData, cta, 'city', aria, this.selectNearby, undefined);
	}

	renderMap() {
		let state = this.state;
		let directions;
		let theaterContainer = this.renderVisualState(s.mapMessage, true);
		const showtimesAppData = this.getPageData();
		const copy = accessNested(this.props, 'store.appData.copy');
		const clientGeo = accessNested(this.props, 'store.client.geo', {});
		const loading = accessNested(this.props, 'store.showtimes.loading') || false;
		const isDesktopSize = this.isDesktop();
		const sharedImageRoot = accessNested(this.props, 'store.appData.urls.roots.sharedImages') || '';
		const showtimesFilters = accessNested(this.props, 'store.showtimes.filters');
		const groupBookings = accessNested(this.props, 'store.appData.pages.boltShowtimes.data.groupBookings', {});

		if (state.mapSelectedTheater) {
			theaterContainer = (
				<div class={s.theaterContainer} key="theaterContainer">
					<Theater
						ref={e => this.$theater = e}
						// onDateChange={this.filtersChange}
						displayedDates={this.getTheaterScrollerDisplayedDates()}
						theater={state.mapSelectedTheater}
						showtimesFilters={showtimesFilters}
						mode={state.mapTheaterExpanded ? 'expanded' : 'collapsed'}
						onExpandClick={() => this.expandCurrentMapTheater()}
						eventInquiryTrigger={() => this.expandTheaterEventInquiry(state.selectedTheater)}
						animateExpansion={state.animateTheaterExpansion}
						clientGeo={clientGeo}
						geoFromIP={state.geoFromIP}
						isDesktopSize={isDesktopSize}
						sharedImageRoot={sharedImageRoot}
						logoShade={this.logoShade}
						copy={copy}
						showtimesAppData={showtimesAppData}
						showFilterSelection={this.showFilterSelection}
						trackConversion={this.trackConversion}
						loading={loading}
						selectedTheater={state.selectedTheater}
						showtimesMode={state.mode}
						divideScreeningsByAttributes
						groupBookings={this.state.selectedTab === GROUP_BOOKINGS_TAB ? groupBookings : {}}
						ticketType={this.state.selectedTab === GROUP_BOOKINGS_TAB ? 'groupbookings' : 'tickets'}
						priorityProviderFromQuery={this.state.priorityProviderFromQuery}
						isMultiMovie={this.isMultiMovie}
					/>
				</div>
			);
			directions = (
				<div class={s.directions} key="directions">
					<Button
						class={joinClasses(s.directionsType, s.walking)}
						trigger={() => this.setDirections('WALKING')}
						ariaLabel={copy.accessibilityCopy.$WALKING_BTN_ARIA}
					>
						<Walk ariaLabel={copy.accessibilityCopy.$WALKING_BTN_ARIA} />
					</Button>
					<Button
						class={joinClasses(s.directionsType, s.driving)}
						trigger={() => this.setDirections('DRIVING')}
						ariaLabel={copy.accessibilityCopy.$CAR_BTN_ARIA}
					>
						<Car ariaLabel={copy.accessibilityCopy.$CAR_BTN_ARIA} />
					</Button>
					<Button
						class={joinClasses(s.directionsType, s.publicTransports)}
						trigger={() => this.setDirections('TRANSIT')}
						ariaLabel={copy.accessibilityCopy.$TRANSPORT_BTN_ARIA}
					>
						<Rail ariaLabel={copy.accessibilityCopy.$TRANSPORT_BTN_ARIA} />
					</Button>
				</div>
			);
		}

		if (loading) {
			// theaterContainer = this.renderDummyElements(1);
			directions = null;
		}

		// In this context disabled = minimized
		const mapDisabled = state.mapTheaterExpanded;
		const strechedMap = !mapDisabled && state.mode !== 'list';
		const mobileMapExpanded = mapDisabled && state.mode !== 'list' && !isDesktopSize;
		let mapAction = mapDisabled ? this.collapseOnMapClick : null;
		// const showtimesFooterBackgroundColorFallback = accessNested(this.props, 'store.appData.styling.variables.tertiaryColor');
		const dualViewEnabled = isDualViewEnabled(this.props.pages);

		return (
			<div class={s.mapView} style={{ top: this.calculateMapPosition() + 'px', bottom: state.mapBottom + 'px' }}>
				<div
					style={{ display: strechedMap ? 'flex' : '' }}
					class={joinClasses(s.theaterScroller, strechedMap && s.stretchedTheaterScroller, dualViewEnabled && s.dualMenu)}
					ref={ref => this.$theaterScroller = ref}
				>
					<div class={joinClasses(s.map, mapDisabled && s.mapDisabled, strechedMap && s.stretched, mobileMapExpanded && s.mobileMapExpanded)} onClickCapture={mapAction} key="map" ariaLabel={copy.accessibilityCopy.$MAP_ARIA}>
						<div class={s.mapElement} ref={e => this.$mapElement = e} key="mapElement" />
						{directions}
						<div class={joinClasses(s.mapOverlay, mapDisabled && s.visible)} />
					</div>
					{theaterContainer}
					<div class={joinClasses(s.suggestions, strechedMap && s.hide, this.props.store?.showtimes?.nearby?.chain?.loading && s.loading)}>
						{this.renderNearbyFromChain(state.mapSelectedTheater)}
					</div>
				</div>
			</div>
		);
	}

	renderProviderInterstitial() {
		const { mode, mapTheaterExpanded } = this.state;
		const shouldShowProviderInterstitial = accessNested(this.props, 'store.showtimes.providerInterstitialOpen', false);
		if (!shouldShowProviderInterstitial) {
			return;
		}

		const selectedTheater = accessNested(this.props, 'store.showtimes.selectedTheater', {});
		const selectedScreening = accessNested(this.props, 'store.showtimes.selectedScreening', {});
		const sharedImageRoot = accessNested(this.props, 'store.appData.urls.roots.sharedImages');
		let storeData = accessNested(this.props, 'store.showtimes');
		const selectedProviders = storeData?.customDataProvider ? storeData.customDataProvider : null;
		const fandangoLink = accessNested(this.props, 'store.showtimes.selectedScreening.link.fandango', null);
		if (selectedProviders && selectedProviders.length === 1 && selectedProviders[0] === 'fandango' && fandangoLink) {
			Store.get().showtimes.set({ providerInterstitialOpen: false });
			window.open(fandangoLink, '_blank');
			return;
		}
		const isDesktopSize = this.isDesktop();
		const copy = accessNested(this.props, 'store.appData.copy');

		let finalMode = mode;
		if (finalMode === 'map') {
			finalMode = mapTheaterExpanded ? 'expanded' : 'collapsed';
		}

		return (
			<ProviderInterstitial
				selectedTheater={selectedTheater}
				selectedScreening={selectedScreening}
				sharedImageRoot={sharedImageRoot}
				logoShade={this.logoShade}
				isDesktopSize={isDesktopSize}
				copy={copy}
				mode={finalMode}
				trackConversion={this.trackConversion}
				key="provider-interstitial"
			/>
		);
	}

	renderVisualState(extraClass, isMap) {
		const {
			data,
			error,
			loading,
			activeVideo = {},
			videosLoading,
			videos = []
		} = this.props.store?.showtimes || {};
		const copy = this.props.store?.appData?.copy || {};
		const deviceSize = this.props.store?.client?.deviceSize;
		const {
			noShowtimes,
			preferNoShowtimesMessage
		} = this.getPageData();
		const { validCountry, searched } = this.state;

		const region = (this.props?.store?.client?.geo?.countryCode || '').toLowerCase();
		const localisations = noShowtimes?.localisations;
		let regionLocalisation;
		if (localisations) {
			regionLocalisation = Object.values(localisations).find(l => {
				if (!l.regions) return false;
				const regions = l.regions.toLowerCase().split(',').map(r => r.trim()).filter(r => r);
				return regions.includes(region);
			});
		}

		let useNoShowtimes = preferNoShowtimesMessage && regionLocalisation;

		const noGeoMessageEnabled = accessNested(this.props, 'store.appData.pages.boltShowtimes.data.noGeolocationMessage', false);
		const clientRegion = accessNested(this.props, 'store.client.geo.region');
		const queryString = parseQueryString();
		if (noGeoMessageEnabled && !loading && !useNoShowtimes && !searched && !clientRegion && (!queryString?.lat || !queryString?.lon)) {
			return (
				<ShowtimesMessage
					deviceSize={deviceSize}
					noCalendar
					message={copy.baseCopy.$ERROR_SHOWTIMES_GEOLOCATION_INSTRUCTION || 'Sorry, we were not able to retrieve your specific location, please enter the city you wish to find showtimes for'}
					key="message-missing-geolocation"
				/>
			);
		}

		if (!validCountry && !loading && !useNoShowtimes) {
			const geo = this.props.store.client.geo;
			const userCity = geo.city || geo.countryCode || '???';
			let regionData = this.props.store.appData.meta.region;
			let uppercaseSlug = (regionData.slug || '').toUpperCase();
			let appRegion = regionData.countryName || uppercaseSlug;
			if (this.boundingRegions?.length > 1 || this.boundingRegions?.[0] !== uppercaseSlug) {
				let sortedRegions = this.boundingRegions?.slice().sort((a, b) => a === uppercaseSlug ? -1 : b === uppercaseSlug ? 1 : 0);
				appRegion = sortedRegions?.join(', ');
			}
			// return showtimes message with suggestion to search new location.
			let cta = copy.baseCopy.$ERROR_SHOWTIMES_LOCATION_CTA || 'Change your search location for new results';
			let message = copy.baseCopy.$ERROR_SHOWTIMES_LOCATION || 'It looks like you’re in %USER_CITY%, and this page is for users in %APP_REGION%';

			return (
				<ShowtimesMessage
					class={extraClass}
					deviceSize={deviceSize}
					isMap={isMap}
					icon="location-pin"
					cta={cta}
					message={message.replace('%USER_CITY%', userCity).replace('%APP_REGION%', appRegion)}
					key="message-bounding-region"
				/>
			);
		}

		if (this.state.socialInterstitial) {
			const userCity = this.props.store.client.geo.city;

			let message = copy.baseCopy.$SOCIAL_INTERSTITIAL_SHOWTIMES_INSTRUCTION || 'It looks like you\'re located in %USER_CITY%<br>Click the button below to display showtimes around you';

			message = message.replace('%USER_CITY%', userCity);

			return (
				<ShowtimesMessage
					class={extraClass}
					deviceSize={deviceSize}
					isMap={isMap}
					message={message}
					buttonCopy={copy.baseCopy.$SOCIAL_INTERSTITIAL_SHOWTIMES_CTA || 'Display Showtimes'}
					buttonTrigger={() => {
						Store.emit('UPDATE_API_KEY');
						Store.emit('LIMIT_EXCEEDED', false);
						this.updateShowtimes();
					}}
					key="message-error"
					icon="location"
				/>
			);
		}

		if (error) {
			return (
				<ShowtimesMessage
					class={extraClass}
					deviceSize={deviceSize}
					isMap={isMap}
					message={copy.baseCopy.$ERROR_SHOWTIMES}
					cta={copy.baseCopy.$ERROR_SHOWTIMES_CTA}
					buttonCopy={copy.baseCopy.$REFRESH || 'Refresh'}
					buttonTrigger={this.updateShowtimes}
					key="message-error"
					icon="calendar-empty"
				/>
			);
		}


		if (!loading && ((data && !data.length) || useNoShowtimes)) {
			let noShowtimesMessage = copy.baseCopy.$NO_SHOWTIMES;
			let noShowtimesCta = copy.baseCopy.$NO_SHOWTIMES_CTA;
			let regionButtonsOverride = {};

			if (regionLocalisation?.title) {
				noShowtimesMessage = copy.baseCopy[regionLocalisation.title] || regionLocalisation.title;
			}
			if (regionLocalisation?.text) {
				noShowtimesCta = copy.baseCopy[regionLocalisation.text] || regionLocalisation.text;
			}

			if (regionLocalisation?.buttons?.filtersButton !== undefined) {
				regionButtonsOverride.filtersButton = regionLocalisation.buttons.filtersButton;
			}

			if (regionLocalisation?.buttons?.extraButton) {
				regionButtonsOverride.extraButton = regionLocalisation.buttons.extraButton;
			}

			return (
				<ShowtimesMessage
					class={extraClass}
					deviceSize={deviceSize}
					isMap={isMap}
					message={noShowtimesMessage}
					cta={noShowtimesCta}
					copy={copy}
					buttonCopy={copy.baseCopy.$FILTERS || 'Filters'}
					buttonTrigger={this.showFilterSelection}
					noShowtimes={!isMap ? noShowtimes : false}
					regionButtonsOverride={regionButtonsOverride}
					noFiltersAvailable={this.noFiltersAvailable}
					activeVideo={activeVideo}
					videosLoading={videosLoading}
					showtimesVideos={videos}
					icon="coming-soon"
					key="message-empty"
				/>
			);
		}
	}

	getTTPosition() {
		let tt = this.getPageData().tt || {};

		if (!tt.titleTreatmentPosition || (!tt.titleTreatmentPosition.desktop && !tt.titleTreatmentPosition.tablet && !tt.titleTreatmentPosition.mobile)) {
			tt = accessNested(this.props, 'store.appData.pages.boltHome.data.tt', {});
		}
		return getValueForClientSize(tt.titleTreatmentPosition);
	}

	safariMobileBlur() {
		if (accessNested(this.props.store, 'client.isIOS')) {
			Store.emit('SAFARI_MOBILE_LOCATION_SEARCH_BLUR');
		}
	}

	safariMobileFocus() {
		if (accessNested(this.props.store, 'client.isIOS')) {
			Store.emit('SAFARI_MOBILE_LOCATION_SEARCH_FOCUS');
		}
	}

	renderLocationSearch(mobileOverlay) {
		const props = this.props;
		const client = props.store.client || {};
		const showtimes = props.store.showtimes || {};

		const showtimesAppData = this.getPageData();

		let extraProps = {};
		if (mobileOverlay) {
			extraProps = {
				mobileOverlayActive: true,
				onBlur: () => Store.emit('SAFARI_MOBILE_LOCATION_SEARCH_BLUR'),
			};
		}

		const onFocus = () => {
			Store.emit('UPDATE_API_KEY');

			if (client.orientation === 'portrait') {
				if (mobileOverlay) {
					if (!this.props.isWidget) {
						Store.emit('SAFARI_MOBILE_LOCATION_SEARCH_FOCUS');
					}
				} else {
					this.enableMobileOverlay();
				}
			}
		};

		const onSelect = () => {
			Store.emit('LIMIT_EXCEEDED', false);
			if (!this.state.searched)
				this.setState({ searched: true });
			this.disableMobileOverlay();
		};

		return (
			<LocationSearch
				class={s.location}
				ref={e => this[mobileOverlay ? '$overlayLocationSearch' : '$locationSearch'] = e}
				disabled={showtimes.loading}
				clientDimensions={client.dimensions}
				geo={client.geo}
				showtimesAppData={showtimesAppData}
				nearbyLocations={showtimes.nearby?.locations?.data}
				isMobile={!client.isDesktopSize}
				onFocus={onFocus}
				onSelect={onSelect}
				onSearch={this.disableMobileOverlay}
				showFilterSelection={this.showFilterSelection}
				selectedFilters={showtimes.filters.selected}
				movieId={showtimes?.movieFilterId}
				{...extraProps}
				key="location-search"
				ticketType={this.state.selectedTab === GROUP_BOOKINGS_TAB ? 'groupbookings' : 'tickets'}
			/>
		);
	}

	renderSelectTitleButton() {
		const fontStyles = accessNested(this.props, 'store.appData.styling.fontVariables');
		const multimovieSelectTitleCopy = accessNested(this.props, 'store.appData.copy.baseCopy.$MULTIMOVIE_SELECT_TITLE');

		return (
			<div class={s.selectTitleBtnContainer}>
				<Button
					class={joinClasses(
						s.selectTitleBtn,
						fontStyles?.headerCta
					)}
					trigger={this.showFilterSelection}
					type="floating"
					ariaLabel={multimovieSelectTitleCopy}
					key="selectTitleButton"
				>
					{multimovieSelectTitleCopy}
				</Button>
			</div>
		);
	}

	renderAttribution() {
		let appData = this.props.store?.appData;
		let pageData = this.getPageData();
		let deeplinkProviders = pageData?.providers?.deeplink?.split(',')?.map(e => e.trim()) || [];
		const countryCode = (this.props?.store?.client?.geo?.countryCode || '').toLowerCase();
		if (deeplinkProviders.includes('cinergy') && countryCode === 'ch') {
			let sharedImageRoot = appData?.urls?.roots?.sharedImages;
			let logoLink = `${sharedImageRoot}/data_providers/${this.logoShade}/cineman_${this.logoShade}.png`;
			let messaging = appData?.copy?.baseCopy?.$SHOWTIMES_BY_CINEMAN;
			return (
				<div class={joinClasses(s.attribution, s.cineman)}>
					<span class={s.showtimesBy}>{messaging}</span>
					<Link href="https://www.cineman.ch/" target="_blank" key="cinergy"><img class={s.logo} src={logoLink} alt="Cineman Logo" height="24" /></Link>
				</div>
			);
		}
	}

	async metaConversionApi(metaClientId) {
		const deviceDetector = new DeviceDetector();
		const device = deviceDetector.parse(navigator.userAgent);
		try {
			console.log('Calling Meta api', {
				event_name: 'ViewContent',
				event_source_url: window.location.href,
				client_user_agent: `${device.client.name}/${device.client.version} (${device.os.name}; ${device.os.version};) ${navigator.language}`,
				client_id: metaClientId
			});
			await metaApi(
				'POST',
				{},
				{
					event_name: 'ViewContent',
					event_source_url: window.location.href,
					client_user_agent: `${device.client.name}/${device.client.version} (${device.os.name}; ${device.os.version};) ${navigator.language}`,
					client_id: metaClientId
				}
			);
		} catch (err) {
			console.error(err);
		}

	}

	render(props) {
		const isShowtimesOnlyIframed = getIsShowtimesOnlyIframed();

		// Not a fan of this but avoids recalculating or passing things down as arguments
		let availableFilters = accessNested(props, 'store.showtimes.filters.available') || {};
		const allShowtimesMovies = accessNested(this.props, 'store.showtimes.allMovies', {});
		this.noFiltersAvailable = !Object.values(availableFilters).some(f => Array.isArray(f) && f.length);

		let state = this.state;
		const { store, isWidget, contentDisabled } = props;
		let { showtimes, client, appData } = store;
		const { copy } = appData;

		let showtimesAppData = this.getPageData();
		const scrollElem = client.isDesktopSize ? this.$listView : this.$scroller;
		const cookies = accessNested(props, 'store.cookies') || {};
		const sonyHeaderEnabled = !isShowtimesOnlyIframed && accessNested(appData, 'options.sonyFeatures.sonyHeader', false);
		const isRTL = accessNested(this.props, 'store.appData.styling.fontVariables.textDirection') === 'rtl';

		const externalBannerOpen = accessNested(store, 'externalCookieBanner.bannerOpen');
		const cookieMode = externalBannerOpen || (accessNested(cookies, 'pushDown', false) && accessNested(cookies, 'cookieBannerOpen', false));
		let style = {};
		if (cookieMode) {
			let cookieHeight = externalBannerOpen ? accessNested(store, 'externalCookieBanner.height') : accessNested(cookies, 'height');
			style.top = cookieHeight + 'px';
			style.height = 'calc(var(--windowHeight) - ' + cookieHeight + 'px)';
		}
		let displayed = showtimes.show;
		let loading = showtimes.loading;
		let showDummyElements = showtimes.loading === undefined ? true : showtimes.loading;

		const pageData = getShowtimesData();
		const groupBookings = pageData?.groupBookings?.isEnabled;
		const hideBookNow = pageData?.groupBookings?.hideBookNow;

		const showtimesFooterBackgroundColorFallback = accessNested(props, 'store.appData.styling.variables.tertiaryColor');

		const dualViewEnabled = isDualViewEnabled(this.props.pages);

		let mapThings = [
			(
				<div
					style={{ top: this.calculateStickedElementsHeight() + 'px' }}
					ref={(e) => this.$modeSelector = e}
					class={joinClasses(s.mapModeContainer, (state.mode === 'map' && !state.mapTheaterExpanded) && s.mapModeVisible)}
					key="map-mode"
				>
					{this.renderModeSelector('map')}
				</div>
			),
			this.renderMap()
		];


		const quickFiltersVisible = (client.isDesktopSize && this.quickFiltersData.visibleDesktop || !client.isDesktopSize && this.quickFiltersData.visibleMobile);
		const quickFiltersWrapped = (client.isDesktopSize && this.quickFiltersData.wrappedDesktop || !client.isDesktopSize && this.quickFiltersData.wrappedMobile);
		const allMoviesInQuickFilters = this.quickFiltersData?.displayOptions?.movie?.trim().toLowerCase() === 'all';
		const showSelectTitleButton = this.quickFiltersData?.showSelectTitleButton;
		const displayScrollArrows = this.quickFiltersData?.displayScrollArrows;
		const quickFiltersTitle = copy?.baseCopy?.[this.quickFiltersData?.title] || this.quickFiltersData?.title;

		const isOnGroupBookingsTab = state.selectedTab === GROUP_BOOKINGS_TAB && this.state.mode === 'eventInquiry';

		const quickFilters = (
			<QuickFilters
				appData={appData}
				isRTL={isRTL}
				isSticky={this.quickFiltersData.isSticky}
				filters={showtimes.filters}
				title={quickFiltersTitle}
				possibleOptions={this.quickFiltersData.displayOptions}
				allMovies={allShowtimesMovies}
				wrappedView={quickFiltersWrapped}
				enablePeeking={this.quickFiltersData.enablePeekingAnimation}
				displayScrollArrows={displayScrollArrows}
			/>
		);

		const creativeSpace = Store.get()?.appData?.options?.showtimesCreativeSpace;

		return (
			<div class={joinClasses(s.wrapper, isWidget && s.widget, this.mapDisabled && s.noMap)} style={style} key="wrapper">
				{creativeSpace && <CreativeSpace toggleMoveDown={this.toggleMoveDown} data={creativeSpace} activated={this.state.movedDown} />}
				{state.mobileOverlayActive && (
					<div class={s.mobileSearchOverlay} key="mobileOverlay">{this.renderLocationSearch(true)}</div>
				)}
				{!state.mobileOverlayActive && !creativeSpace && (
					<MovieDetails
						type="showtimes"
						tt={showtimesAppData.tt}
						bg={showtimesAppData.bg}
						buttons={showtimesAppData.buttons}
						visible={isWidget || (props.store.showtimes.show && state.ttVisible)}
						hide={!state.ttVisible}
						copy={copy}
						appData={appData}
						cookieMode={cookieMode}
						class={joinClasses(s.movieDetails, (!client.isDesktopSize && this.state.dateScrollerSticked) && s.blur)}
						sonyHeaderEnabled={sonyHeaderEnabled}
						key="movieDetails"
						dualViewEnabled={dualViewEnabled}
						isWidget={isWidget}
					/>
				)}
				{this.state.mode !== 'eventInquiry' ? (
					<div
						class={joinClasses({
							s,
							container: true,
							creativeSpace: creativeSpace,
							movedDown: this.state.movedDown,
							animate: showtimes.animate,
							sonyHeader: sonyHeaderEnabled,
							showtimesOnlyIframed: isShowtimesOnlyIframed,
							displayed,
							loading,
							filterSelectionActive: state.filterSelection,
							mapTheaterExpanded: state.mapTheaterExpanded,
							animateTheaterExpansion: state.animateTheaterExpansion
						}, s['mode-' + state.mode])}
						ref={e => this.$container = e}
						key="container"
						style={{ pointerEvents: contentDisabled ? 'none' : 'all' }}
					>
						<div class={joinClasses(s.filterSelectionContainer, !this.state.sameCountry && s.disableFilters)} key="filters">
							<FilterSelection
								appData={appData}
								client={client}
								filters={showtimes.filters}
								onSubmit={this.filtersChange}
								allShowtimesMovies={allShowtimesMovies}
								ref={e => this.$filterSelection = e}
								open={state.filterSelection}
								onCancel={this.hideFilterSelection}
							/>
						</div>
						{this.renderProviderInterstitial()}
						<div
							id="showtimesScroller"
							class={joinClasses(
								s.scroller,
								state.mode !== 'map' && s.list,
								this.state.dateScrollerSticked && s.sticked,
								(isOnGroupBookingsTab && state.mode !== 'map' && groupBookings && client.isDesktopSize) && s.accomodateBookingTabs
							)}
							style={{
								scrollPadding: `${this.calculateStickedElementsHeight()}px 0px 0px 0px`
							}}
							ref={e => this.$scroller = e}
							data-section="scroller"
							onClick={this.scrollerClick}
							onScroll={this.handleScroll}
							key="scroller"
						>
							{(state.mode !== 'map' && !isShowtimesOnlyIframed) && !creativeSpace && (
								<MovieDetailsClickableArea
									fallbackClickHandler={isWidget ? this.props.exitWidget : this.hideShowtimes}
									isWidget={isWidget}
									dualViewEnabled={dualViewEnabled}
								/>
							)}

							<div class={s.content} ref={e => this.$content = e} key="content">
								{!!groupBookings && (
									<div class={s.tabsContainer}>
										{!hideBookNow && (
											<button
												class={joinClasses(s.tab, state.selectedTab === BOOK_NOW_TAB && s.selected)}
												onClick={this.selectTabTickets}
											>
												<span>{copy.baseCopy.$BOOK_NOW_TAB}</span>
											</button>
										)}
										<button
											class={joinClasses(s.tab, state.selectedTab === GROUP_BOOKINGS_TAB && s.selected)}
											onClick={this.selectTabGroupBookings}
										>
											<span>{copy.baseCopy.$GROUP_BOOKINGS_TAB}</span>
										</button>
									</div>
								)}
								{dualViewEnabled && (
									<DualMenu
										key="dualMenu"
										ref={e => this.onStickedElementRef(e, 'dualMenu', true)}
										isWidget={isWidget && 'showtimes'}
										widgetData={props.widgetData}
										pages={this.props.pages}
									/>
								)}
								<div
									id="scrollSearch"
									class={joinClasses(s.scrollSearch, dualViewEnabled && s.dualMenu)}
									ref={e => this.onStickedElementRef(e, 'location', true)}
									onTouchStart={this.onCHTouchStart}
									onTouchMove={this.onCHTouchMove}
									key="header"
								>
									{this.renderLocationSearch()}
								</div>
								<div
									id="scrollDates"
									class={joinClasses(s.scrollDates, this.state.dateScrollerSticked && s.sticked)}
									ref={e => this.onStickedElementRef(e, 'filtersDate')}
								>
									<DateScroller
										ref={e => this.$filterDate = e}
										appData={appData}
										showtimesAppData={showtimesAppData}
										client={client}
										isSticked={this.state.dateScrollerSticked}
										displayedDates={this.getDisplayedDates()}
										scrollElem={scrollElem}
										// onChange={this.filtersChange}
										selectedTheater={this.state.selectedTheater}
										showtimesMode={this.state.mode}
										mapMode={state.mapTheaterExpanded ? 'expanded' : 'collapsed'}
									/>
									{showSelectTitleButton && this.isMultiMovie && !allMoviesInQuickFilters && this.renderSelectTitleButton()}
									{quickFiltersVisible && this.quickFiltersData.isSticky && quickFilters}
								</div>
								{quickFiltersVisible && !this.quickFiltersData.isSticky && quickFilters}
								{!quickFiltersVisible && (
									<div
										class={joinClasses(s.scrollPadding)}
										ref={e => this.onStickedElementRef(e, 'scrollPadding', true)}
									/>
								)}
								<div
									id="showtimesList"
									class={s.listView}
									ref={e => this.$listView = e}
									key="list"
									onScroll={e => this.props.handleWidgetScroll && this.props.handleWidgetScroll(e)}
								>
									<div>
										<div class={s.listModeContainer} key="selector">{this.renderModeSelector('list')}</div>
										{this.renderVisualState()}
										{showDummyElements ? this.renderDummyElements(8) : this.renderElements()}
										<div class={s.suggestions} key="suggestions">
											{this.renderNearbyScreeningsLocations()}
										</div>
									</div>
									{this.renderAttribution()}
									<div class={s.filler} key="filler" />
									{!isWidget && (
										<Footer
											data={props.store.appData.footer}
											parent="showtimes"
											scrollElem={scrollElem}
											fallBackColor={showtimesFooterBackgroundColorFallback}
											key="footer"
											store={props.store}
										/>
									)}
								</div>
							</div>
							{client.isDesktopSize && mapThings}
							{this.state.groupBookingsSubmitted && this.renderGroupBookingSubmitted()}
						</div>
						{!client.isDesktopSize && mapThings}
					</div>
				) : (
					<div
						class={joinClasses({
							s,
							container: true,
							animate: showtimes.animate,
							sonyHeader: sonyHeaderEnabled,
							showtimesOnlyIframed: isShowtimesOnlyIframed,
							displayed,
							loading,
							filterSelectionActive: state.filterSelection,
							animateTheaterExpansion: state.animateTheaterExpansion
						}, s['mode-' + state.mode])}
						ref={e => this.$container = e}
						key="eventInquiry"
						style={{ pointerEvents: contentDisabled ? 'none' : 'all', top: !client.isDesktopSize ? '85px' : '' }}
					>
						<GroupBookingsInquiry
							key={this.state.selectedTheater?.id}
							client={client}
							chainId={this.state.selectedTheater?.chainId}
							formData={this.state.formData}
							logoShade={this.logoShade}
							store={store}
							selectedTheater={this.state.selectedTheater}
							onChange={this.updateGroupBookingsFormData}
							goBack={this.exitEventInquiry}
						/>
					</div>
				)}
			</div>
		);
	}
}

class ReactIntersectionObserver {
	constructor(fn, options) {
		if (options.repeat) {
			this.repeatMax = options.repeat.max;
			this.repeatEvery = options.repeat.every;
			delete options.repeat;
		}

		this.fn = fn;
		this.onResult = this.onResult.bind(this);
		this.elementToProps = [];
		this.observer = new IntersectionObserver(this.onResult, options);
	}

	onResult(r, o) {
		this.enchanceOnResult(r, o);
	}

	enchanceOnResult(r, o, num = 0) {
		window.clearTimeout(this.repeatTimeout);
		this.fn(r, this);
		if (num < this.repeatMax) {
			this.repeatTimeout = window.setTimeout(
				() => this.enchanceOnResult(r, o, num + 1),
				this.repeatEvery
			);
		}
	}

	destroy() {
		this.elementToProps.forEach((x) => this.unobserve(x[0]));
	}

	observe(elem, props) {
		this.elementToProps.push([elem, props]);
		return this.observer.observe(elem);
	}

	unobserve(elem) {
		this.elementToProps = this.elementToProps.filter(([x]) => x !== elem);
		return this.observer.unobserve(elem);
	}

	getProps(elem) {
		return (this.elementToProps.find(([x]) => x === elem) || [])[1] || {};
	}

	getClosestToY(y) {
		const withBoundingBox = this.elementToProps.map((e) => {
			let rect = e[0].getBoundingClientRect();
			if (!rect.top && !rect.bottom) {
				rect = Object.assign({}, rect, {
					top: Infinity
				});
			}
			return [...e, rect];
		});

		const isAnyAtTop = withBoundingBox.find(([, , rect], idx) => {
			return rect.top <= y;
		});
		if (!isAnyAtTop) {
			return [null, null];
		}

		return withBoundingBox.reduce((acc, e, idx) => {
			const [, , rect] = e;
			const isVisible = rect.top + rect.height >= y;
			const distanceToTop = Math.abs(rect.top - y);
			if (isVisible && distanceToTop < acc.distanceToTop) {
				acc.distanceToTop = distanceToTop;
				acc.result = e;
			}
			return acc;
		}, { distanceToTop: Infinity, result: null }).result || [];
	}

	getLastVisible() {
		const withBoundingBox = this.elementToProps.map((e) => {
			let rect = e[0].getBoundingClientRect();
			if (!rect.top && !rect.bottom) {
				rect = Object.assign({}, rect, {
					top: Infinity
				});
			}
			return [...e, rect];
		});

		const isAnyVisible = withBoundingBox.find(([, , x], idx) => x.top < Infinity);
		if (!isAnyVisible) {
			return [null, null];
		}

		return withBoundingBox.reduce((acc, e, idx) => {
			const [, , rect] = e;
			const lastTop = rect.top;
			if (lastTop < Infinity && lastTop > acc.lastTop) {
				acc.lastTop = lastTop;
				acc.result = e;
			}
			return acc;
		}, { lastTop: 0, result: null }).result || [];
	}
}

function withIntersectionObserver(Comp) {
	class IntersectionObserverComp extends Component {
		constructor(props) {
			super(props);
			this.$el = {};
		}

		componentDidMount() {
			if (this.props.intersectionObserver) {
				this.intersectionObserver = this.props.intersectionObserver;
				this.observe();
			}
		}

		observe() {
			if (this.intersectionObserver && this.$el && this.$el.base instanceof window.Element) {
				this.prevEl = this.$el.base;
				this.intersectionObserver.observe(this.$el.base, this.props);
			}
		}

		unobserve() {
			if (this.intersectionObserver && this.prevEl) {
				this.intersectionObserver.unobserve(this.prevEl);
			}
		}

		componentDidUpdate(prevProps) {
			if (this.props.intersectionObserver !== this.intersectionObserver) {
				this.unobserve();
				this.intersectionObserver = this.props.intersectionObserver;
				this.observe();
			} else if (this.$el.base !== this.prevEl) {
				this.unobserve();
				this.observe();
			}
		}

		componentWillUnmount() {
			this.unobserve();
			this.intersectionObserver = null;
			// gb hack
			// Store.get().set({ groupBookingsShowtimes: false });
		}

		render() {
			return (
				<Comp ref={e => this.$el = e} {...this.props} intersectionObserver={null} />
			);
		}
	}
	return IntersectionObserverComp;
}